import { render } from "./LangSwitcher.vue?vue&type=template&id=5bda9af8&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import "./LangSwitcher.vue?vue&type=style&index=0&id=5bda9af8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bda9af8"]])

export default __exports__